import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      valentineData: null,
      valentineKey: null
    };
  },
  mutations: {
    setValentineData: function setValentineData(state, data) {
      state.valentineData = data;
    },

    /**
     * 图片key
     */
    setValentineKey: function setValentineKey(state, key) {
      state.valentineKey = key;
    }
  },
  actions: {
    recordValentine: function recordValentine(_a, key) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              // 已经提交过了，不再提交
              if (state.valentineKey === key) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/temp_activity/valentine', {
                image: key
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setValentineKey', key);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;